import {
  Calendar,
  CoinsStacked03,
  ReceiptBill,
} from '@branch-messenger/willow-ui/icons'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMediaQuery } from '@uidotdev/usehooks'

import { centsToDollar } from '@/lib/currency'
import { formatISODateToDayMonDD } from '@/lib/date-helpers'
import {
  ewaPayrollScheduleQueryOptions,
  ewaTransactionBalanceQueryOptions,
} from '@/queries/ewa'
import { mediaQueries } from '@/styles/media'

import {
  AdvanceInfoContainer,
  AdvanceInfoItemDivider,
  AdvanceInfoItemText,
  AdvanceInfoList,
  HeaderDivider,
} from '../styles'
import { AdvanceInfoItem } from './AdvanceInfoItem'

export const AdvanceInfo = () => {
  const isLargeTabletAndDown = useMediaQuery(mediaQueries.largeTabletAndDown)
  const isLargeTabletAndUp = useMediaQuery(mediaQueries.largeTabletAndUp)
  const { data: payrollSchedule } = useSuspenseQuery(
    ewaPayrollScheduleQueryOptions
  )
  const { data: transactionBalance } = useSuspenseQuery(
    ewaTransactionBalanceQueryOptions
  )
  const currentPayrollPayDate = payrollSchedule?.current?.pay_date
  const totalAdvanced = transactionBalance?.amount_owed ?? 0

  return (
    <AdvanceInfoContainer>
      <AdvanceInfoList>
        <AdvanceInfoItem
          title={'Total advanced'}
          value={centsToDollar(totalAdvanced)}
          icon={CoinsStacked03}
        />
        <AdvanceInfoItemDivider />
        <AdvanceInfoItem
          title={'Payback on'}
          value={formatISODateToDayMonDD(currentPayrollPayDate)}
          icon={Calendar}
        />
        <AdvanceInfoItem
          title={'Payback method'}
          value={'Paycheck Deduction'}
          icon={ReceiptBill}
          hide={isLargeTabletAndDown}
        />
      </AdvanceInfoList>
      {isLargeTabletAndDown && (
        <AdvanceInfoItemText $italicized $size="xs" $color="textMuted">
          {`Any advances you take this pay period will be deducted from your next paycheck.`}
        </AdvanceInfoItemText>
      )}
      {isLargeTabletAndUp && <HeaderDivider />}
    </AdvanceInfoContainer>
  )
}
